export const SIM_MODEL = {
  INTERPOLATING: '9ee20415-dada-46e6-8644-5a004fee1659',
  MODFLOW: 'a6596448-5a8f-4e76-b83e-2a1e0b7a33a5',
  FEMWATER_MESH: 'bb40be2c-c537-4f52-9ac0-4dd1f0d06cbf',
  FEMWATER: '005f4927-7c00-4b58-865c-5c751dc0dcc5',
  MASSBALANCE: 'e64e5fc3-74b8-4a5e-a284-d570224a87e3'
}
